import { Moment } from 'moment';

export class CertificateValidity {
  constructor(private readonly notBefore: Moment | null, private readonly notAfter: Moment | null) {}

  getNotBefore() {
    return this.notBefore;
  }

  getNotAfter() {
    return this.notAfter;
  }
}
